import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';

interface OfflineBannerProps {
   isOnline: boolean;
}

function OfflineBanner({ isOnline }: OfflineBannerProps) {
   return (
      <AnimatePresence>
         {!isOnline && (
            <motion.div
               initial={{ opacity: 0, y: -10 }}
               animate={{ opacity: 1, y: 0 }}
               exit={{ opacity: 0, y: -10 }}
               className="mb-4 p-3 bg-yellow-500/20 border border-yellow-500/50 rounded text-yellow-400 text-xs font-mono text-center"
            >
               You are offline. Version 1 requires internet access for all features.
            </motion.div>
         )}
      </AnimatePresence>
   );
}

export default OfflineBanner;
